import { User, Building2 } from "lucide-react";

/**
 * Source of truth for sign-up types. Add a new entry here and the chooser
 * (SignUpPage) will render it automatically. The form (SignUpFormPage) will
 * accept the new value via /sign-up/:type once you branch on it inside.
 */
export const SIGNUP_TYPES = [
  {
    value: "individual",
    label: "Individual Investor Registration",
    icon: User,
  },
  {
    value: "corporate",
    label: "Corporate Investor Registration",
    icon: Building2,
  },
];

export const SIGNUP_TYPE_VALUES = SIGNUP_TYPES.map((t) => t.value);

export const signUpPathFor = (type) => `/sign-up/${type}`;
